import { connect } from 'react-redux';
import SalesloftConfigurationView from './SalesloftConfigurationView.jsx';
import { updateConfiguration} from 'src/legacy/redux/actions/integrations/salesloft.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.salesloft.changes.error,
    updating: state.legacyRootReducer.settings.integrations.salesloft.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.salesloft.changes.loading,
    user: state.users.me,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    }
  }
}

const SalesloftConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SalesloftConfigurationView);

export default SalesloftConfigurationPage;
